var A = { exports: {} }, f = {};
/**
 * @license React
 * react.react-server.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var w;
function G() {
  if (w) return f;
  w = 1;
  var v = { H: null, A: null };
  function E(t) {
    var r = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      r += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        r += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return "Minified React error #" + t + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var g = Array.isArray, c = Symbol.for("react.transitional.element"), P = Symbol.for("react.portal"), C = Symbol.for("react.fragment"), Y = Symbol.for("react.strict_mode"), $ = Symbol.for("react.profiler"), k = Symbol.for("react.forward_ref"), U = Symbol.for("react.suspense"), L = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), d = Symbol.iterator;
  function D(t) {
    return t === null || typeof t != "object" ? null : (t = d && t[d] || t["@@iterator"], typeof t == "function" ? t : null);
  }
  var m = Object.prototype.hasOwnProperty, I = Object.assign;
  function R(t, r, n, u, o, s, e) {
    return n = e.ref, {
      $$typeof: c,
      type: t,
      key: r,
      ref: n !== void 0 ? n : null,
      props: e
    };
  }
  function H(t, r) {
    return R(
      t.type,
      r,
      null,
      void 0,
      void 0,
      void 0,
      t.props
    );
  }
  function a(t) {
    return typeof t == "object" && t !== null && t.$$typeof === c;
  }
  function j(t) {
    var r = { "=": "=0", ":": "=2" };
    return "$" + t.replace(/[=:]/g, function(n) {
      return r[n];
    });
  }
  var N = /\/+/g;
  function y(t, r) {
    return typeof t == "object" && t !== null && t.key != null ? j("" + t.key) : r.toString(36);
  }
  function O() {
  }
  function V(t) {
    switch (t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw t.reason;
      default:
        switch (typeof t.status == "string" ? t.then(O, O) : (t.status = "pending", t.then(
          function(r) {
            t.status === "pending" && (t.status = "fulfilled", t.value = r);
          },
          function(r) {
            t.status === "pending" && (t.status = "rejected", t.reason = r);
          }
        )), t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw t.reason;
        }
    }
    throw t;
  }
  function l(t, r, n, u, o) {
    var s = typeof t;
    (s === "undefined" || s === "boolean") && (t = null);
    var e = !1;
    if (t === null) e = !0;
    else
      switch (s) {
        case "bigint":
        case "string":
        case "number":
          e = !0;
          break;
        case "object":
          switch (t.$$typeof) {
            case c:
            case P:
              e = !0;
              break;
            case S:
              return e = t._init, l(
                e(t._payload),
                r,
                n,
                u,
                o
              );
          }
      }
    if (e)
      return o = o(t), e = u === "" ? "." + y(t, 0) : u, g(o) ? (n = "", e != null && (n = e.replace(N, "$&/") + "/"), l(o, r, n, "", function(z) {
        return z;
      })) : o != null && (a(o) && (o = H(
        o,
        n + (o.key == null || t && t.key === o.key ? "" : ("" + o.key).replace(
          N,
          "$&/"
        ) + "/") + e
      )), r.push(o)), 1;
    e = 0;
    var _ = u === "" ? "." : u + ":";
    if (g(t))
      for (var i = 0; i < t.length; i++)
        u = t[i], s = _ + y(u, i), e += l(
          u,
          r,
          n,
          s,
          o
        );
    else if (i = D(t), typeof i == "function")
      for (t = i.call(t), i = 0; !(u = t.next()).done; )
        u = u.value, s = _ + y(u, i++), e += l(
          u,
          r,
          n,
          s,
          o
        );
    else if (s === "object") {
      if (typeof t.then == "function")
        return l(
          V(t),
          r,
          n,
          u,
          o
        );
      throw r = String(t), Error(
        E(
          31,
          r === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : r
        )
      );
    }
    return e;
  }
  function p(t, r, n) {
    if (t == null) return t;
    var u = [], o = 0;
    return l(t, u, "", "", function(s) {
      return r.call(n, s, o++);
    }), u;
  }
  function W(t) {
    if (t._status === -1) {
      var r = t._result;
      r = r(), r.then(
        function(n) {
          (t._status === 0 || t._status === -1) && (t._status = 1, t._result = n);
        },
        function(n) {
          (t._status === 0 || t._status === -1) && (t._status = 2, t._result = n);
        }
      ), t._status === -1 && (t._status = 0, t._result = r);
    }
    if (t._status === 1) return t._result.default;
    throw t._result;
  }
  function q() {
    return /* @__PURE__ */ new WeakMap();
  }
  function T() {
    return { s: 0, v: void 0, o: null, p: null };
  }
  return f.Children = {
    map: p,
    forEach: function(t, r, n) {
      p(
        t,
        function() {
          r.apply(this, arguments);
        },
        n
      );
    },
    count: function(t) {
      var r = 0;
      return p(t, function() {
        r++;
      }), r;
    },
    toArray: function(t) {
      return p(t, function(r) {
        return r;
      }) || [];
    },
    only: function(t) {
      if (!a(t)) throw Error(E(143));
      return t;
    }
  }, f.Fragment = C, f.Profiler = $, f.StrictMode = Y, f.Suspense = U, f.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = v, f.cache = function(t) {
    return function() {
      var r = v.A;
      if (!r) return t.apply(null, arguments);
      var n = r.getCacheForType(q);
      r = n.get(t), r === void 0 && (r = T(), n.set(t, r)), n = 0;
      for (var u = arguments.length; n < u; n++) {
        var o = arguments[n];
        if (typeof o == "function" || typeof o == "object" && o !== null) {
          var s = r.o;
          s === null && (r.o = s = /* @__PURE__ */ new WeakMap()), r = s.get(o), r === void 0 && (r = T(), s.set(o, r));
        } else
          s = r.p, s === null && (r.p = s = /* @__PURE__ */ new Map()), r = s.get(o), r === void 0 && (r = T(), s.set(o, r));
      }
      if (r.s === 1) return r.v;
      if (r.s === 2) throw r.v;
      try {
        var e = t.apply(null, arguments);
        return n = r, n.s = 1, n.v = e;
      } catch (_) {
        throw e = r, e.s = 2, e.v = _, _;
      }
    };
  }, f.cloneElement = function(t, r, n) {
    if (t == null)
      throw Error(E(267, t));
    var u = I({}, t.props), o = t.key, s = void 0;
    if (r != null)
      for (e in r.ref !== void 0 && (s = void 0), r.key !== void 0 && (o = "" + r.key), r)
        !m.call(r, e) || e === "key" || e === "__self" || e === "__source" || e === "ref" && r.ref === void 0 || (u[e] = r[e]);
    var e = arguments.length - 2;
    if (e === 1) u.children = n;
    else if (1 < e) {
      for (var _ = Array(e), i = 0; i < e; i++)
        _[i] = arguments[i + 2];
      u.children = _;
    }
    return R(t.type, o, null, void 0, void 0, s, u);
  }, f.createElement = function(t, r, n) {
    var u, o = {}, s = null;
    if (r != null)
      for (u in r.key !== void 0 && (s = "" + r.key), r)
        m.call(r, u) && u !== "key" && u !== "__self" && u !== "__source" && (o[u] = r[u]);
    var e = arguments.length - 2;
    if (e === 1) o.children = n;
    else if (1 < e) {
      for (var _ = Array(e), i = 0; i < e; i++)
        _[i] = arguments[i + 2];
      o.children = _;
    }
    if (t && t.defaultProps)
      for (u in e = t.defaultProps, e)
        o[u] === void 0 && (o[u] = e[u]);
    return R(t, s, null, void 0, void 0, null, o);
  }, f.createRef = function() {
    return { current: null };
  }, f.forwardRef = function(t) {
    return { $$typeof: k, render: t };
  }, f.isValidElement = a, f.lazy = function(t) {
    return {
      $$typeof: S,
      _payload: { _status: -1, _result: t },
      _init: W
    };
  }, f.memo = function(t, r) {
    return {
      $$typeof: L,
      type: t,
      compare: r === void 0 ? null : r
    };
  }, f.use = function(t) {
    return v.H.use(t);
  }, f.useCallback = function(t, r) {
    return v.H.useCallback(t, r);
  }, f.useDebugValue = function() {
  }, f.useId = function() {
    return v.H.useId();
  }, f.useMemo = function(t, r) {
    return v.H.useMemo(t, r);
  }, f.version = "19.0.0-rc-f2df5694-20240916", f;
}
var M;
function x() {
  return M || (M = 1, A.exports = G()), A.exports;
}
var K = x();
const h = K.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
export {
  h as __SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE
};
//# sourceMappingURL=react-server-internals.js.map
